module.exports = __webpack_public_path__ + "media/images/elvis-87f08eb4db3d1906c0aca5ccfbbd4110.png";